// extracted by mini-css-extract-plugin
module.exports = {"root":"Param_root__3NS9g","valueCheck":"Param_valueCheck__2rVbd","valueCross":"Param_valueCross__2-FRA"};